<template>
  <div class="col-12 col-xl">
    <div class="graph-and-filters">
      <div class="graph-auto">
        <div class="graph-auto__wrapp">
          <highcharts :key="chartKey" v-if="chartKey > 0" :options="chartOptions" :constructor-type="'stockChart'"></highcharts>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Chart } from 'highcharts-vue'
import stockInit from 'highcharts/modules/stock'
import Highcharts from 'highcharts'
import 'flatpickr/dist/themes/dark.css'
import '@/assets/css/js-datapicer.scss'
import graphConfigs from '@/components/graphConfigs'
import data from '@/api/data'
import moment from 'moment'
import object from 'lodash'

stockInit(Highcharts)

export default {
  name: 'Lines',
  mixins: [graphConfigs],
  components: {
    'highcharts': Chart
  },
  methods: {
    loadData () {
      data.lineValues(this.$route.params.id, {
        from: moment()
          .subtract(2, 'hours').utc()
          .format('YYYY-MM-DD HH:mm:ss')
      }).then(r => {
        const series = []

        object.forOwn(r.data.v1Line, (values, key) => {
          const device = this.$store.getters['station/devices'].find(device => device.id === Number(key))

          series.push({
            data: values,
            name: `${device.name} V1 line`
          })
        })

        object.forOwn(r.data.v2Line, (values, key) => {
          const device = this.$store.getters['station/devices'].find(device => device.id === Number(key))

          series.push({
            data: values,
            name: `${device.name} V2 line`
          })
        })

        object.forOwn(r.data.v3Line, (values, key) => {
          const device = this.$store.getters['station/devices'].find(device => device.id === Number(key))

          series.push({
            data: values,
            name: `${device.name} V3 line`
          })
        })

        object.forOwn(r.data.v1Phase, (values, key) => {
          const device = this.$store.getters['station/devices'].find(device => device.id === Number(key))

          series.push({
            data: values,
            name: `${device.name} V1 phase`
          })
        })

        object.forOwn(r.data.v2Phase, (values, key) => {
          const device = this.$store.getters['station/devices'].find(device => device.id === Number(key))

          series.push({
            data: values,
            name: `${device.name} V2 phase`
          })
        })

        object.forOwn(r.data.v3Phase, (values, key) => {
          const device = this.$store.getters['station/devices'].find(device => device.id === Number(key))

          series.push({
            data: values,
            name: `${device.name} V3 phase`
          })
        })

        this.chartOptions.series = series
        this.chartKey++
      })
    }
  },
  data () {
    return {
      polling: null,
      chartKey: 0,
      chartOptions: {
        chart: {
          alignTicks: false,
          marginLeft: 0,
          height: 310
        },
        navigator: {
          enabled: false
        },
        scrollbar: {
          enabled: false
        },
        series: [
          {
            data: [],
            name: 'Voltage'
          }
        ],
        xAxis: {
          labels: {
            style: {
              color: '#fff'
            }
          }
        },
        rangeSelector: false,
        yAxis: [{ // Primary yAxis
          labels: {
            format: '{value} V',
            style: {
              color: '#FFFFFF'
            }
          },
          gridLineColor: '#4f5051',
          title: {
            text: 'Voltage',
            style: {
              color: '#FFFFFF'
            }
          },
          opposite: true
        }]
      }
    }
  },
  created () {
    this.loadData()

    this.polling = setInterval(this.loadData, 1000 * 120)
  },
  beforeDestroy () {
    clearInterval(this.polling)
  }
}
</script>
